import PeriodType from '@/models/enums/statistics/PeriodType'
import { formatNumAsString } from '@/util/num-format'
import {
  createWeekPeriodBlock,
  createMonthPeriodBlock,
  createYearPeriodBlock,
  createArrowUpIcon,
  createArrowDownIcon,
} from '@/util/revenue-dynamics/tooltip'

// formatNumAsString возвращает 0 как есть (falsy), поэтому нули приводим к строке отдельно.
function formatValue (value) {
  return value ? formatNumAsString(value) : '0'
}

// Шапка: дата выбранного периода и дата сравнения, формат зависит от периода.
export function createStackedHeader (periodType, dates) {
  const header = document.createElement('div')
  header.style.padding = '8px 12px'
  header.style.borderBottom = '1px solid #7E7E7E'
  header.style.whiteSpace = 'nowrap'

  switch (periodType) {
    case PeriodType.Month: header.appendChild(createMonthPeriodBlock(dates)); break
    case PeriodType.Year: header.appendChild(createYearPeriodBlock(dates)); break
    default: header.appendChild(createWeekPeriodBlock(dates))
  }

  return header
}

// Иконка коннектора нарисована силуэтом, поэтому красим её в цвет серии через CSS-маску.
function createIcon (iconPath, color) {
  const icon = document.createElement('span')
  icon.style.display = 'inline-block'
  icon.style.flexShrink = 0
  icon.style.width = '16px'
  icon.style.height = '16px'
  icon.style.marginRight = '6px'
  icon.style.backgroundColor = color
  icon.style.webkitMaskImage = `url(${iconPath})`
  icon.style.maskImage = `url(${iconPath})`
  icon.style.webkitMaskRepeat = 'no-repeat'
  icon.style.maskRepeat = 'no-repeat'
  icon.style.webkitMaskPosition = 'center'
  icon.style.maskPosition = 'center'
  icon.style.webkitMaskSize = 'contain'
  icon.style.maskSize = 'contain'

  return icon
}

// Строка коннектора: маркер цвета серии, иконка, название, значения обоих периодов.
export function createStackedRow (row) {
  const line = document.createElement('div')
  line.style.display = 'flex'
  line.style.alignItems = 'center'
  line.style.margin = '4px 0'
  line.style.whiteSpace = 'nowrap'

  const marker = document.createElement('span')
  marker.style.background = row.color
  marker.style.borderRadius = '3px'
  marker.style.width = '12px'
  marker.style.height = '12px'
  marker.style.marginRight = '8px'
  marker.style.flexShrink = 0

  const name = document.createElement('span')
  name.style.color = '#D3D5D9'
  name.style.marginRight = '24px'
  name.appendChild(document.createTextNode(row.label))

  const values = document.createElement('span')
  values.style.marginLeft = 'auto'

  const value = document.createElement('span')
  value.style.color = '#FF9D00'
  value.appendChild(document.createTextNode(formatValue(row.value)))

  const prevValue = document.createElement('span')
  prevValue.style.color = '#9B9B9B'
  prevValue.appendChild(document.createTextNode(' / ' + formatValue(row.prevValue)))

  values.appendChild(value)
  values.appendChild(prevValue)

  line.appendChild(marker)

  if (row.icon) {
    line.appendChild(createIcon(row.icon, row.color))
  }

  line.appendChild(name)
  line.appendChild(values)

  return line
}

export function createStackedBody (rows) {
  const body = document.createElement('div')
  body.style.padding = '8px 12px'

  rows.forEach(row => body.appendChild(createStackedRow(row)))

  return body
}

// Подвал: суммы обоих периодов по видимым коннекторам и разница со стрелкой.
export function createStackedTotal (total, prevTotal) {
  const footer = document.createElement('div')
  footer.style.padding = '8px 12px'
  footer.style.borderTop = '1px solid #7E7E7E'
  footer.style.whiteSpace = 'nowrap'

  const totals = document.createElement('div')
  totals.style.display = 'flex'
  totals.style.alignItems = 'center'
  totals.style.fontSize = '16px'

  const caption = document.createElement('span')
  caption.style.color = '#D3D5D9'
  caption.style.marginRight = '24px'
  caption.appendChild(document.createTextNode('Итого'))

  const values = document.createElement('span')
  values.style.marginLeft = 'auto'
  values.appendChild(document.createTextNode(`${formatValue(total)} / ${formatValue(prevTotal)}`))

  totals.appendChild(caption)
  totals.appendChild(values)

  const difference = document.createElement('div')
  difference.style.display = 'flex'
  difference.style.alignItems = 'center'
  difference.style.fontSize = '16px'
  difference.style.marginTop = '4px'

  const diff = total - prevTotal
  const diffValue = document.createElement('span')
  diffValue.appendChild(document.createTextNode(formatValue(Math.abs(diff))))

  if (diff >= 0) {
    diffValue.style.color = '#6AAD00'
    difference.appendChild(createArrowUpIcon())
  } else {
    diffValue.style.color = '#E92663'
    difference.appendChild(createArrowDownIcon())
  }

  difference.appendChild(diffValue)

  footer.appendChild(totals)
  footer.appendChild(difference)

  return footer
}

// Собирает содержимое подсказки в переданный (уже очищенный) контейнер.
export function renderStackedTooltip (tooltipEl, { periodType, dates, rows, total, prevTotal }) {
  // Базовый контейнер из tooltip.js выкладывает содержимое в строку - для списка нужен блок.
  tooltipEl.style.display = 'block'
  tooltipEl.style.padding = 0
  tooltipEl.style.fontSize = '14px'

  tooltipEl.appendChild(createStackedHeader(periodType, dates))
  tooltipEl.appendChild(createStackedBody(rows))
  tooltipEl.appendChild(createStackedTotal(total, prevTotal))
}
